import React from "react";
import { useTranslation } from "react-i18next";
import { useRolesRetrieval } from "@planzone/view-models";
import { TextInput } from "@common/textInput";
import { RoleSelection } from "@common/roleSelection";
import { Props } from "./types";
import { Columns } from "./columns";
import styles from "./styles.scss";

function Form({ project, formData, usedRoles, edit }: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectDetailsConfiguration.name")}
        </h2>
        <TextInput
          placeholder={t("projectDetailsConfiguration.name")}
          value={formData.name}
          input={(name) => edit({ ...formData, name })}
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectDetailsConfiguration.roles")}
        </h2>
        <div className={styles.roleSelection}>
          <RoleSelection
            selectedRoleIds={formData.roles}
            rolesToExclude={[
              ...usedRoles,
              ...roles
                .filter(
                  (role) =>
                    role.name !== "pz_admin" && role.name !== "pr_manager",
                )
                .map(({ uuid }) => uuid),
            ]}
            placeholder={t("projectDetailsConfiguration.roles")}
            select={(role) =>
              edit({
                ...formData,
                roles: [...formData.roles, role.name],
              })
            }
            unSelect={(role) =>
              edit({
                ...formData,
                roles: formData.roles.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectDetailsConfiguration.columns")}
        </h2>
        <Columns project={project} formData={formData} edit={edit} />
      </div>
    </div>
  );
}

export { Form };
